/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { skipAutoDateConversion } from '../../../api-dates';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RedirectUrlDto as FeatureSettingsRedirectUrlDto } from '../../models/feature/settings/redirect-url-dto';

export interface GetCustomerPortalUrl$Params {
  returnUrl: string;
}

export function getCustomerPortalUrl(http: HttpClient, rootUrl: string, params: GetCustomerPortalUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<FeatureSettingsRedirectUrlDto>> {
  const rb = new RequestBuilder(rootUrl, getCustomerPortalUrl.PATH, 'get');
  if (params) {
    rb.query('returnUrl', params.returnUrl, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context: skipAutoDateConversion(context) })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FeatureSettingsRedirectUrlDto>;
    })
  );
}

getCustomerPortalUrl.PATH = '/settings/subscription/customer-portal-url';

